import { calculateCenterPositions } from './calculate-center-positions.js';
import type { RelativeAbsolutePosition } from '../../../types/pointer-events.js';

/**
 * Calculates initial selection are positions for when the selection area is not invoked by a pointer
 * @param areaWidth -
 * @param bounds
 */
export const calculateInitialSelectionAreaPositions = (
  bounds: DOMRect,
): [RelativeAbsolutePosition, RelativeAbsolutePosition] => {
  const { height, left, top, width } = bounds;
  const areaWidth = width / 3;
  const middlePosition = calculateCenterPositions(width, height, top, left);

  const selectionStart: RelativeAbsolutePosition = {
    relative: {
      x: middlePosition.relative.x - areaWidth / 2,
      y: middlePosition.relative.y,
    },
    absolute: {
      x: middlePosition.absolute.x - areaWidth / 2,
      y: middlePosition.absolute.y,
    },
  };

  const selectionEnd: RelativeAbsolutePosition = {
    relative: {
      x: middlePosition.relative.x + areaWidth / 2,
      y: middlePosition.relative.y,
    },
    absolute: {
      x: middlePosition.absolute.x + areaWidth / 2,
      y: middlePosition.absolute.y,
    },
  };

  return [selectionStart, selectionEnd];
};
